import Store from 'redux/store';

import {
  FETCH_MOBILE_OPERATOR,
  FETCH_MOBILE_OPERATOR_FAIL,
  FETCH_MOBILE_OPERATOR_SUCCESS,
  SAVE_MOBILE_RECHARGE,
  SAVE_MOBILE_RECHARGE_SUCCESS,
  SAVE_MOBILE_RECHARGE_FAIL,
  FETCH_AREACODES,
  FETCH_AREACODES_FAIL,
  FETCH_AREACODES_SUCCESS,
  FECTH_RECHARGEVALUE,
  FECTH_RECHARGEVALUE_FAIL,
  FECTH_RECHARGEVALUE_SUCCESS,
} from 'redux/Reducers/MobileOperator/MobileOperatorReducer';
import { cloudloyalty } from '../clients';
import { extractNumber } from 'Utils/onlyNumbers';

export const FetchMobileOperator = async (User, finallyCallback = () => {}) => {
  Store.dispatch({ type: FETCH_MOBILE_OPERATOR });

  cloudloyalty(User)
    .get(`/v1/mobileRecharges/mobileoperator`)
    .then((response) => {
      Store.dispatch({
        type: FETCH_MOBILE_OPERATOR_SUCCESS,
        payload: {
          statusCode: response.status,
          data: response.data,
        },
      });
    })
    .catch((e) => {
      Store.dispatch({
        type: FETCH_MOBILE_OPERATOR_FAIL,
        error: e,
        payload: {
          statusCode: e.response.status,
        }
      });
    })
    .finally(() => {
      finallyCallback();
    });
};
export const FetchAreaCode = async (
  User,
  finallyCallback = () => {},
  { operatorKey }
) => {
  Store.dispatch({ type: FETCH_AREACODES });
  cloudloyalty(User)
    .get(`/v1/mobileRecharges/mobileoperator/${operatorKey}/areacode`)
    .then((response) => {
      Store.dispatch({
        type: FETCH_AREACODES_SUCCESS,
        payload: {
          data: response.data,
        },
      });
    })
    .catch((e) => {
      Store.dispatch({
        type: FETCH_AREACODES_FAIL,
        error: e,
      });
    })
    .finally(() => {
      finallyCallback();
    });
};

export const FetchRechargeValue = async (
  User,
  finallyCallback = () => {},
  { operatorKey, areaCode }
) => {
  Store.dispatch({ type: FECTH_RECHARGEVALUE });

  cloudloyalty(User)
    .get(
      `/v1/mobileRecharges/mobileoperator/${operatorKey}/areacode/${areaCode}/rechargeValue`
    )
    .then((response) => {
      Store.dispatch({
        type: FECTH_RECHARGEVALUE_SUCCESS,
        payload: {
          statusCode: response?.status,
          data: response.data,
        },
      });
    })
    .catch((e) => {
      Store.dispatch({
        type: FECTH_RECHARGEVALUE_FAIL,
        error: e,
        payload: {
          statusCode: e?.response?.status,
        }
      });
    })
    .finally(() => {
      finallyCallback();
    });
};

export const SaveMobileRecharge = async (
  User,
  finallyCallback = () => {},
  { serviceId, operatorKey, areaCode, phone }
) => {
  Store.dispatch({ type: SAVE_MOBILE_RECHARGE });

  const validateFundsPurchase = (serviceId) => {
    return cloudloyalty(User)
      .post('/v1/purchases/ValidateFundsPurchase', {
        TypeValidate: 3,
        Service: { Type: 1, ServiceId: serviceId },
        ChannelType: 1,
      })
      .then((response) => {
        return response.status === 200;
      })
      .catch((error) => {
        Store.dispatch({
          type: SAVE_MOBILE_RECHARGE_FAIL,
          payload: {
            statusCode: error?.response?.status,
          },
          error: error,
        });
        return false;
      });
  };

  const InsertService = (serviceId, operatorKey, areaCode, phone) => {
    cloudloyalty(User)
      .post('/v1/purchases/service', {
        serviceId: serviceId.toString(),
        type: 1,
        configuration: [
          {
            key: 'OPERADORA',
            value: operatorKey,
          },
          { key: 'DDD', value: areaCode.toString() },
          { key: 'PHONE', value: extractNumber(phone).toString() },
        ],
      })
      .then((response) => {
        Store.dispatch({
          type: SAVE_MOBILE_RECHARGE_SUCCESS,
          payload: {
            statusCode: response?.status,
            ...response.data,
          },
        });
      })
      .catch((error) => {
        Store.dispatch({
          type: SAVE_MOBILE_RECHARGE_FAIL,
          error: error,
          payload: {
            statusCode: error?.response?.status,
            data: error?.response?.data
          }
        });
      })
      .finally(() => {
        finallyCallback();
      });
  };

  validateFundsPurchase(serviceId).then((validate) => {
    if (validate) InsertService(serviceId, operatorKey, areaCode, phone);
  });
};
